import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import App, { AppProps } from './app/app';
import theme from './app/styles/theme/theme';
import store from './app/store/store';
import { init18n } from './i18n';
import ParamsProvider from './app/params/params-provider';
import NetworkProvider from './app/network/network-provider';

// eslint-disable-next-line import/prefer-default-export
export const init = (config: AppProps): void => {
  init18n(config.locale, window.location.href);
  ReactDOM.render(
    <ParamsProvider
      portalTypeProp={config.portal}
      user={config.user}
      utm={config.utm}
      activeIcon={config.activeIcon}
      locale={config.locale}
      pages={config.pages}>
      <Provider store={store}>
        <NetworkProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </NetworkProvider>
      </Provider>
    </ParamsProvider>,
    document.getElementById('ucf-container')
  );
};
